import { Dictionary } from 'lodash';
import { AlgoliaConfig } from './AlgoliaDevicePicker';

export type Hierarchy = { [title: string]: Hierarchy } | null;

export interface Wiki {
   title: string;
   display_title: string;
   summary: string;
   image: string;
}

export enum View {
   Grid = 'GRID',
   Column = 'COLUMN',
}

export type State = 'category' | 'search';

export type DevicePickerContextType = {
   state: State;
   query: string;
   category: string;
   hierarchy?: Hierarchy;
   displayTitles?: Dictionary<string>;
   leaves: Set<string> | null;
   setState: (state: State) => void;
   setQuery: (query: string) => void;
   setCategory: (category: string) => void;
};

export interface DevicePickerProps {
   fetchHierarchy: () => Promise<{
      hierarchy: Hierarchy;
      display_titles: Dictionary<string>;
   }>;
   fetchChildren: (title: string) => Promise<Array<Wiki>>;
   onSubmit: (title: string) => void;
   onCancel: () => void;
   allowOrphan?: boolean;
   initialDevice?: string;
   initialView?: View;
   objectName?: string;
   algoliaConfig?: AlgoliaConfig;
   onSearch?: (value: string) => void;
}
